import {useSelector} from 'react-redux';

import BadgesGrid from '@/components/BadgesGrid/BadgesGrid';
import useBadgeDetailRoute from '@/hooks/useBadgeDetailRoute';
import {selectInProgressBadges} from '@/state/selectors/loyalty';
import type {BadgesInProgressCollectionSectionContentModel} from '@/types/aem';

type BadgesInProgressCollectionSectionProps = {
    content?: BadgesInProgressCollectionSectionContentModel | null;
};

const BadgesInProgressCollectionSection = ({content}: BadgesInProgressCollectionSectionProps) => {
    const inProgressBadges = useSelector(selectInProgressBadges);
    const {actionsRemainingPluralForms} = content ?? {};
    const {openBadge} = useBadgeDetailRoute();

    return (
        <BadgesGrid
            className='mt-2 px-4'
            badges={inProgressBadges}
            showProgress
            actionsRemainingPluralForms={actionsRemainingPluralForms ?? undefined}
            onBadgeClick={openBadge}
        />
    );
};

export default BadgesInProgressCollectionSection;
